<template>
    <div class="container-fluid pt-3">
        <div class="box page-plans">
            <div>
                <h1 class="pull-left">{{ t('plans-title') }}</h1>
                <router-link class="btn btn-primary pull-right" :to="'/plans/add/'"
                    >{{ t('plans-add_plan_button') }}</router-link
                >
            </div>

            <table class="table table-stripped mt-6">
                <tr v-for="plan in plans" :key="plan.id">
                    <td>
                        {{ plan.name }}
                    </td>
                    <td>
                        <router-link
                            class="btn btn-primary"
                            :to="'/plans/edit/' + plan.id"
                            >{{ t('plans-edit_button') }}</router-link
                        >
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi";

export default {
    data: () => ({
        plans: [],
    }),
    mounted() {
        this.loadPlans();
    },
    methods: {
        loadPlans() {
            let options = keviApi.getOptions("plans", "GET");
            this.$http(options).then((response) => {
                this.plans = response.body.plans;
            });
        },
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
